<template>
  <div class="box3">
    <img src="../../../assets/coursePage/media/box3/img.png" alt="" />
    <div class="titlebox">
      <div class="title">用户规模迅速增长<br />占据互联网流量高地</div>
      <div class="subtitle">
        短视频用户正从年轻化走向全民化，并渗透至生活全场景<br />成为内容传播渠道标配
      </div>
    </div>
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="table"></div>
          <div class="info">
            <p>
              2023年3月2日，中国互联网络信息中心（CNNIC）发布第51次《中国互联网络发展状况统计报告》。
            </p>
            <p>
              《报告》显示，截至2022年12月，短视频用户规模达
              <span>10.12亿，</span>用户使用率高达 <span>94.8%</span>
            </p>
            <p>
              以抖音为例，2022年1-11月，
              <span>月均热点视频播放量可达4000亿+。</span>
            </p>
          </div>
          <div class="exp">
            数据来源：中国互联网络信息中心、网经社、 抖音热点&巨量算数
          </div>
        </swiper-slide>
        <swiper-slide><Box4 /> </swiper-slide>
        <swiper-slide>
          <Box5 />
          <div class="seize"></div>
        </swiper-slide>
      </swiper>

      <!-- <div class="swiper-pagination-box3"></div> -->
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    Box4,
    Box5,
  },

  data() {
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        // pagination: {
        //   el: ".swiper-pagination-box3",
        // },
      },
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box3 {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("../../../assets/coursePage/media/box3/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .seize {
    width: 32px;
  }
  img {
    width: 722px;
    display: block;
    margin: 60px auto 0;
  }
  .titlebox {
    text-align: center;
    margin-top: 80px;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-top: 11px;
    }
  }
  .subject-content {
    position: relative;
    display: flex;
    width: 100%;
    box-sizing: border-box;
  }

  .swiper-slide:nth-child(2),
  .swiper-slide:nth-child(1) {
    width: 660px;
    height: 736px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(136, 97, 255, 0.12);
    border-radius: 20px;

    position: relative;
    // margin: 48px 0px 118px 32px;
    margin: 48px 0px 88px 32px;
    .text-box {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: absolute;
      top: 508px;
      left: 24px;
      padding-bottom: 15px;
      width: 100%;

      box-sizing: border-box;
      p {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      // transform: translateY(286px);
      opacity: 1;
      transition: 0.5s all;
    }
  }
  .swiper-slide:nth-child(3) {
    width: 680px;
    height: 736px;
    display: flex;
    margin: 48px 0px 88px 32px;
    border-radius: 20px;

    position: relative;
  }
  // .swiper-pagination-box3 {
  //   display: flex;
  //   align-items: center;
  //   position: absolute;
  //   left: 50%;
  //   bottom: 80px;
  //   transform: translate(-50%, 0px);
  //   height: 6px;
  //   background: #b7a9ff;
  //   border-radius: 3px;

  //   display: none;
  // }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #775cff;
    border-radius: 3px;
  }
  .table {
    width: 628px;
    height: 332px;
    background: url("../../../assets/coursePage/media/box3/table.png") no-repeat;
    background-size: cover;
    margin: 16px auto 0;
    box-sizing: border-box;
    overflow: hidden;
  }
  .info {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0d004d;
    line-height: 44px;
    margin: 32px auto 0px;
    padding: 0 32px;
    box-sizing: border-box;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-bottom: 16px;
      text-align: justify;
    }
    span {
      color: rgba(255, 0, 0, 1);
      font-size: 24px;
      font-family: PingFangSC-Medium;
    }
  }
  .exp {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bac2d0;
    line-height: 36px;
    margin-left: 32px;
  }
}
</style>
